// extracted by mini-css-extract-plugin
module.exports = {"termsOfUseContainer":"TermsOfUse_termsOfUseContainer__3JU4D","termsOfUseList":"TermsOfUse_termsOfUseList__e6RGJ"};